module.exports = __webpack_public_path__ + "static/media/mandolin.88a98365.svg";